import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { BodyText } from '@garnish/core';

// ─────────────────────────────────────────────────────────────────────────────

export const QuantityStepperQuantity = (props: Props) => {
  const { quantity, size = 'md', fitToContent = false } = props;

  return (
    <View style={fitToContent ? styles.containerFitToContent : styles.container}>
      <BodyText sizeMatch={[size === 'sm' ? '18' : '22']} maxFontSizeMultiplier={1}>
        {quantity}
      </BodyText>
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    paddingHorizontal: theme.spacing['1'],
  },
  containerFitToContent: {
    flexGrow: 1,
    flexShrink: 0,
    alignItems: 'center',
    paddingHorizontal: theme.spacing['1'],
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = PropsWithChildren<{
  quantity: number;
  size?: 'sm' | 'md';
  fitToContent?: boolean;
}>;
